import { render } from "./RightSidebar.vue?vue&type=template&id=a142955a"
const script = {}

import exportComponent from "/home/dbomfim/projects/mstr2023/appv3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__